<template>
    <div>
        <!--导航栏 start-->
        <van-nav-bar
                left-text="返回"
                fixed
                title="商户管理"
                left-arrow
                @click-left="onClickLeft"

        >
            <!--通过插槽自定义导航栏右侧的内容 end-->
        </van-nav-bar>
        <!--导航栏 end-->
        <!-- 列表 start-->
        <van-grid :column-num="3" :border="false" style="margin-top: 1rem">
            <van-grid-item  text="商户编号" />
            <van-grid-item  text="商户名称" />
            <van-grid-item  text="状态" />
<!--            <van-grid-item  text="业务员名称" />-->
        </van-grid>
        <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="init"
        >
<!--           -->
            <van-cell v-for="item in list" :key="item.merchant_id"  @click="agent_info(item.merchant_id)" >
                <van-grid :column-num="3" :border="false">
                    <van-grid-item :text="item.merchant_num" />
                    <van-grid-item :text="item.bse_lice_nm" />
                    <van-grid-item>
                        <van-tag style="position: relative;left: 0.2rem" :type="item.merchant_status==0?'primary ':'success'">{{item.merchant_status==0?'待审核':'已审核'}}</van-tag>
                    </van-grid-item>
<!--                    <van-grid-item :text="item.salesman_name?item.salesman_name:'&#45;&#45;'" />-->


                    <!--                    <van-grid-item v-if="item.is_audit_status == 1">审核中</van-grid-item>-->
                    <!--                    <van-grid-item v-if="item.is_audit_status == 0">已审核</van-grid-item>-->
                </van-grid>
            </van-cell>
        </van-list>
        <!-- 列表 end-->
    </div>
</template>

<script>
    import Vue from 'vue';
    import {List, Grid, GridItem, } from 'vant';
    // import VueCookie from "vue-cookies";

    Vue.use(Grid);
    Vue.use(GridItem);
    Vue.use(List);

    export default {
        name: "MerchantList",
        data(){
            return{
                list: [],
                page:1,
                limit:10,
                loading: false,
                finished: false,
            }
        },
        methods:{
            // 返回上一级
            onClickLeft() {
                // 返回商户信息
                this.$router.push('/AgentHomepage');
            },
            // onClickRight(){
            //     this.$router.push('/SalesmanLoginAgent')
            // },
            init() {
                var that = this;
                // var salesmanInfo = VueCookie.get("salesmanInfo");
                this.$http.get('/wechat/api.agent.merchant/listMerchant', {
                    params: {
                        // id: salesmanInfo.id,
                        pageNum: that.page,
                        pageSize:that.limit
                    }
                }).then(response => {
                    // 加载状态结束
                    that.loading = false;
                    // console.log(response.data.data)
                    that.list = that.list.concat(response.data.rows)
                    // 页码
                    that.page++;
                    // this.finished = true;
                    if (response.data.rows.length < that.limit)
                    {
                        that.finished = true;
                    }
                });
            },
            agent_info(id) {
                // this.$router.push("/SalesmanUpdate/"+id);
                this.$router.push({path:"/MerchantInfoymm", query:{id:id}})
                // this.$router.push({path:"/SalesmanUpdate", params:{id:id}})
            },
            // agent_detail(id){
            //     this.$http.post('/wechat/api.agent.salesman/delSalesman', {
            //         salesman_id:id,
            //         openid: window.localStorage.getItem("openid")
            //     }).then(response => {
            //         if (response && response.data.code== 200) {
            //             Notify({type: 'danger', message: response.data.msg});
            //             setTimeout(()=>{
            //                 this.$router.go(0)
            //             },300)
            //
            //
            //         }
            //     })
            // },
        },
        mounted(){

        }
    }
</script>

<style scoped>

</style>
